import iPhone13Pro from './iPhone13Pro.png';

type iPhone13ProProps = {
  alt?: string;
  className?: string;
};

export const UpdatediPhone13Pro: React.FC<iPhone13ProProps> = ({ alt = 'iPhone 13 Pro', className }) => {
  return <img src={iPhone13Pro} alt={alt} className={className} />;
};
